import styled from 'styled-components'
import {
  purple,
  purpleDisabled,
  purpleDark,
  purpleSec,
  white,
  yellowThr,
  grayText,
  black,
  blackLight
} from '@qirapagos/lib/theme/colors'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px;
`

export const ContentBox = styled.div`
  width: 1044px;
  background: ${white};
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.09);
  border-radius: 6px;
  padding: 24px 24px 40px;
  display: flex;
  flex-direction: column;
  gap: 0;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 54px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33%;
  gap: 16px;
`

export const ActionsBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0px;
  gap: 48px;
  align-items: center;
`

export default Wrapper

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 1044px;
  margin: 0 auto;
  margin-top: 160px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 24px 48px;
  gap: 48px;
  width: 100%;
  background: ${white};
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.09);
  border-radius: 6px;
`

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 100%;
  margin-bottom: 4px;
`

export const DisclaimerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0px 16px;
  gap: 4px;
  width: 100%;
  margin-top: 0px;
  margin-bottom: 48px;
`

export const AlertSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
  width: 206px;
  height: 23px;
`

export const WarningIcon = styled.div`
  width: 23px;
  height: 23px;
  background: ${yellowThr};
  border: 2px solid ${yellowThr};
  border-radius: 50%;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 31.25%;
    width: 2px;
    height: 6px;
    background: ${white};
    transform: translateX(-50%);
    border-radius: 1px;
  }

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 28.12%;
    width: 2px;
    height: 2px;
    background: ${white};
    transform: translateX(-50%);
    border-radius: 50%;
  }
`

export const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px;
  gap: 54px;
  width: 100%;
`

export const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 40px;
  gap: 182px;
  width: 100%;
`

export const DetailGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 16px;
  flex: 1;
`

export const DetailLabel = styled.div`
  width: 100%;
  text-align: center;
`

export const DetailValue = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
`

export const ButtonsSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 48px;
  width: 100%;
`

export const BackButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 16px;
  width: 160px;
  height: 53px;
  background: ${purpleSec};
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${purpleDisabled};
  }
`

export const ConfirmButton = styled.button<{ $isLoading?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 16px;
  gap: 8px;
  width: 300px;
  height: 52px;
  background: ${({ $isLoading }) => ($isLoading ? purpleDisabled : purple)};
  border-radius: 6px;
  border: none;
  cursor: ${({ $isLoading }) => ($isLoading ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${purpleDark};
  }

  &:disabled {
    background: ${purpleDisabled};
    cursor: not-allowed;
  }
`

export const LoadingIcon = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid ${white};
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

export const Bold = styled.span`
  font-weight: 600;
  font-family: 'Poppins';
`

export const styles = {
  titleText: {
    color: black,
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '154.7%'
  },
  disclaimerText: {
    color: grayText,
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '154.7%',
    textAlign: 'left' as const
  },
  alertText: {
    color: yellowThr,
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '154.7%',
    display: 'flex',
    alignItems: 'center'
  },
  labelText: {
    color: grayText,
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '100%',
    textAlign: 'center' as const,
    letterSpacing: '0.01em'
  },
  valueText: {
    color: blackLight,
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center' as const
  },
  backButtonText: {
    color: purple,
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '154.7%',
    textAlign: 'center' as const
  },
  confirmButtonText: {
    color: white,
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '154.7%',
    textAlign: 'center' as const
  }
}
